import React from 'react';
import { useAccountStore } from '@components/Stores/accountStore';
import { IPositionMaterial } from '@sp-types/financialPositionType';
import {
  doughnutToMap,
  FinancialMaterialSkeleton,
  materialsToDoughnut,
  positionsMaterialColumns,
  spreadMaterialsMonths,
} from './components/FinancialPositionsUtils';

import { DashBoardDonutCard } from '../../components/UI-Elements/DashBoardDonutCard';
import { FutureOrdersSummaryLegend } from '../FutureOrder/FutureOrders/FutureOrdersSummeryGraphs/FutureOrdersSummeryGraphsCharts/FutureOrdersSummaryLegend';
import { FilterButtons } from './components/FilterButtons';
import BasicTable, { Row } from './components/BasicTable';
import { FutureOrdersSummeryBarChart } from '../FutureOrder/FutureOrders/FutureOrdersSummeryGraphs/FutureOrdersSummeryGraphsCharts/FutureOrdersSummeryBarChart';
import { useMaterialsStore } from '../../components/Stores/MaterialsStore';

interface Props {
  positions?: IPositionMaterial[];
  setMaterial: (_materialId: string) => void;
}

export const FinancialPositionsGeneral: React.FC<Props> = ({ positions, setMaterial }) => {
  const { materialColorDictionary: colorsMap } = useAccountStore();
  useMaterialsStore();

  const [selectedTable, setSelectedTable] = React.useState('Material');

  const groupTableBy = [
    { value: 'Material', icon: 'material', disabled: false },
    { value: 'Month', icon: 'calender', disabled: true },
    { value: 'Order', icon: 'orders', disabled: true },
  ];

  const rowClick = ({ original }: Row) => {
    setMaterial(original.materialId);
  };

  return positions ? (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col bg-white shadow-custom p-3 justify-between max-h-60">
        <h6 className="flex gap-2">Summary</h6>
        <div className="flex flex-1 gap-4">
          <div className="w-48 p-4">
            <DashBoardDonutCard secondaryTitle="Net value" dataSet={materialsToDoughnut(positions)} />
          </div>
          <div className="flex my-auto min-w-[14rem] overflow-y-scroll max-h-[12rem]">
            <FutureOrdersSummaryLegend
              materialsDataAsDictionary={doughnutToMap(materialsToDoughnut(positions))}
              colorsMap={colorsMap}
              itemNames={positions.reduce((acc, { materialName: name }) => ({ ...acc, [name]: { name } }), {})}
            />
          </div>
          <div className="flex-1">
            <FutureOrdersSummeryBarChart
              materialsDataAsDictionary={spreadMaterialsMonths(positions)}
              colorsMap={colorsMap}
              itemNames={positions.reduce(
                (acc, { materialName: name, materialId }) => ({ ...acc, [materialId]: { name } }),
                {},
              )}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-col flex-1 bg-white shadow-custom  justify-between">
        <div className="flex flex-row h-full">
          <FilterButtons {...{ groupTableBy, selectedTable, setSelectedTable }} />
        </div>
        <div className="flex flex-row h-full">
          <BasicTable allRows={positions} columns={positionsMaterialColumns} options={{ rowClick }} />
        </div>
      </div>
    </div>
  ) : (
    <FinancialMaterialSkeleton />
  );
};
